<template>
  <div class="soc-change" ref="socChangeRef">
    <div class="soc-inner" :style="getStyle()">
      <div class="soc-start-soc" :style="{ left: `calc(${props.startSoc}% - ${startOffset}px - 4px)` }" ref="startLabelRef">
        S:{{ props.startSoc }}%
      </div>
      <div class="soc-end-soc" :style="{ left: `calc(${props.endSoc}% - ${endOffset}px - 4px)` }" ref="endLabelRef">
        E:{{ props.endSoc }}%
      </div>
      <svg class="soc-triangle" :style="{ left: `calc(${props.startSoc}% - 4px)` }" width="6" height="5" viewBox="0 0 6 5"
        fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M3.09903 4.5C2.90658 4.83333 2.42545 4.83333 2.233 4.5L0.0679397 0.749999C-0.12451 0.416666 0.116053 -5.28905e-07 0.500953 -4.95256e-07L4.83108 -1.16704e-07C5.21598 -8.30548e-08 5.45654 0.416666 5.26409 0.75L3.09903 4.5Z"
          fill="var(--color)" />
      </svg>
      <svg class="soc-triangle" :style="{ left: `calc(${props.endSoc}% - 4px)` }" width="6" height="5" viewBox="0 0 6 5" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M3.09903 4.5C2.90658 4.83333 2.42545 4.83333 2.233 4.5L0.0679397 0.749999C-0.12451 0.416666 0.116053 -5.28905e-07 0.500953 -4.95256e-07L4.83108 -1.16704e-07C5.21598 -8.30548e-08 5.45654 0.416666 5.26409 0.75L3.09903 4.5Z"
          fill="var(--color)" />
      </svg>

      <div class="soc-bar" :style="{ width: `${props.startSoc}%` }" :class="{ 'end': isCharging }"></div>
      <div class="soc-bar" :style="{ width: `${props.endSoc}%` }" :class="{ 'end': !isCharging }"></div>
    </div>
  </div>
</template>

<script setup>
import { useTemplateRef, computed, ref, onMounted, onUpdated } from 'vue';
const socChangeRef = useTemplateRef('socChangeRef');

const startOffset = ref(0);
const endOffset = ref(0);


const startLabelRef = useTemplateRef('startLabelRef');
const endLabelRef = useTemplateRef('endLabelRef');


const isCharging = computed(() => {
  return props.startSoc < props.endSoc;
});



const props = defineProps({
  startSoc: {
    type: Number,
    required: true,
  },
  endSoc: {
    type: Number,
    required: true,
  },
})

function isIntersecting(rect1, rect2) {
  return !(rect1.right < rect2.left ||
    rect1.left > rect2.right ||
    rect1.bottom < rect2.top ||
    rect1.top > rect2.bottom);
}

function getStyle() {
  return {
    '--color': isCharging.value ? '#39BE3E' : '#FD5938',
    '--bg-color': isCharging.value ? '#CBF1DD' : '#FED4C8',
    '--end-color': isCharging.value ? '#7EBF40' : '#FA8640'
  }
}

function updateOffsets() {
  if (!startLabelRef.value || !endLabelRef.value) return;
  const startRect = startLabelRef.value.getBoundingClientRect();
  const endRect = endLabelRef.value.getBoundingClientRect();
  const space = 10
  if (isIntersecting(startRect, endRect)) {
    if (isCharging.value) {
      const offset = Math.abs(endRect.left - startRect.right) + space;
      startOffset.value = offset;
    } else {
      const offset = Math.abs(startRect.left - endRect.left) + space;
      endOffset.value = offset;
    }
  }
}

onMounted(() => {
  updateOffsets();
})

onUpdated(() => {
  updateOffsets();
})


</script>


<style scoped lang="scss">
.soc-change {
  width: 120px;
  height: 50px;
  position: relative;
}

.soc-inner {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  height: 8px;
  width: 100%;
  border-radius: 5px;
  background: var(--bg-color);
}

.soc-bar {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 0;
  background: var(--color);
  border-radius: 5px;

  &.end {
    z-index: 1;
    background: var(--end-color);
  }
}

.soc-triangle {
  position: absolute;
  left: 0;
  top: -8px;
  z-index: 2;
  fill: var(--color);
}

.soc-start-soc {
  text-align: left;
}

.soc-end-soc {
  text-align: right;
}

.soc-start-soc,
.soc-end-soc {
  position: absolute;
  // border: 1px solid blue;
  left: -2px;
  top: -24px;
  z-index: 2;
  white-space: nowrap;
}
</style>
